import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { DellWarranty } from "../models/DellWarranty";
import { getWarrantyBySerials } from "../services/dellWarranty.service";


interface IDellWarrantyState {
    dellWarranty: DellWarranty[];
    loading: boolean;
    fetchedKey: string | null;
}

const initialState: IDellWarrantyState = {
    dellWarranty: [],
    loading: false,
    fetchedKey: null,
}

export const dellWarrantySlice = createSlice({
    name: "dellWarranty",
    initialState,
    reducers: {
        clearDellWarranty: (state) => {
            state.dellWarranty = [];
            state.fetchedKey = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWarrantyBySerials.pending, (state, action) => {
                state.loading = true;
                // Remember what we're fetching so the condition can dedupe in-flight calls.
                state.fetchedKey = (action.meta.arg ?? "").trim();
            })
            .addCase(getWarrantyBySerials.fulfilled, (state, action) => {
                state.dellWarranty = Array.isArray(action.payload) ? action.payload : [];
                state.loading = false;
                state.fetchedKey = (action.meta.arg ?? "").trim();
            })
            .addCase(getWarrantyBySerials.rejected, (state) => {
                state.loading = false;
                // Clear key on failure so a retry is allowed.
                state.fetchedKey = null;
            })
    }
});

export const { clearDellWarranty } = dellWarrantySlice.actions;
export const selectDellWarranty = (state: RootState) => state.dellWarranty.dellWarranty;
export const dellWarrantyReducer = dellWarrantySlice.reducer;
